// extracted by mini-css-extract-plugin
export default {"removeMessages--content":"removeMessages_removeMessages--content__RAuXr","removeMessages--content-btnContainer":"removeMessages_removeMessages--content-btnContainer__2Ib5r"};